import axios from "axios";
import { getUserId } from "./user";

// Host dashboards often show a URL without its scheme. A bare host here would
// silently make every request relative to the frontend's own origin, so assume
// https when no scheme is given.
const rawBackend = (process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/+$/, "");
const BACKEND_URL = rawBackend && !/^https?:\/\//i.test(rawBackend) ? `https://${rawBackend}` : rawBackend;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API, timeout: 150000, withCredentials: true });

export const api = {
  getUser: (uid) => http.get(`/user/${uid}`).then((r) => r.data),
  listSessions: (uid) => http.get(`/sessions`, { params: { userId: uid } }).then((r) => r.data),
  getSession: (id) => http.get(`/sessions/${id}`).then((r) => r.data),
  deleteSession: (id) => http.delete(`/sessions/${id}`).then((r) => r.data),
  createSession: (topic) => http.post(`/sessions`, { topic, userId: getUserId() }).then((r) => r.data),
  submitStage0: (id, answers, confidence) => http.post(`/sessions/${id}/stage0/submit`, { answers, confidence }).then((r) => r.data),
  getStage1: (id) => http.get(`/sessions/${id}/stage1`).then((r) => r.data),
  stage1Retry: (id) => http.post(`/sessions/${id}/stage1/retry`).then((r) => r.data),
  regenSection: (id, sectionId) => http.post(`/sessions/${id}/stage1/regenerate-section`, { sectionId }).then((r) => r.data),
  recordShaky: (id, concept) => http.post(`/sessions/${id}/stage1/record-shaky`, { concept }).then((r) => r.data),
  stage2Turn: (id, message) => http.post(`/sessions/${id}/stage2/turn`, { message }).then((r) => r.data),
  enterTeach: (id) => http.post(`/sessions/${id}/stage2/enter`).then((r) => r.data),
  stage2Fix: (id, weaknessId) => http.post(`/sessions/${id}/stage2/fix`, { weaknessId }).then((r) => r.data),
  stage2Verify: (id, wid, message) => http.post(`/sessions/${id}/stage2/fix/${wid}/verify`, { message }).then((r) => r.data),
  stage3Generate: (id) => http.post(`/sessions/${id}/stage3/generate`).then((r) => r.data),
  stage3Submit: (id, answers, confidence) => http.post(`/sessions/${id}/stage3/submit`, { answers, confidence }).then((r) => r.data),
  patchNotes: (id, notes) => http.patch(`/sessions/${id}/notes`, { notes }).then((r) => r.data),
  patchTime: (id, timeSpentSec) => http.patch(`/sessions/${id}/time`, { timeSpentSec }).then((r) => r.data),
  tts: (text, speed, voice = "nova") => http.post(`/tts`, { text, speed, voice }).then((r) => r.data),
  authConfig: () => http.get(`/auth/config`).then((r) => r.data),
  authMe: () => http.get(`/auth/me`).then((r) => r.data),
  authLogout: () => http.post(`/auth/logout`).then((r) => r.data),
};
